<template>
  <div class="RoomStatus">
    <div v-if="pageLoading" class="loading">
      <img src="../../image/loading.gif" alt="" />
    </div>
    <el-form
      v-show="!pageLoading"
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
    >
      <el-form-item label="输入查询：">
        <el-input
          v-model="formInline.title"
          placeholder="请输入房源标题"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="房型查询：" class="left_margin">
        <el-select v-model="formInline.number" placeholder="请选择房型" clearable>
          <el-option label="1室" value="1"></el-option>
          <el-option label="2室" value="2"></el-option>
          <el-option label="3室" value="3"></el-option>
          <el-option label="4室" value="4"></el-option>
          <el-option label="5室及以上" value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="left_margin">
        <el-button type="primary" @click="onSubmit" class="inquire"
          >搜索</el-button
        >
        <el-button type="primary" class="reset" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="main" v-show="!pageLoading">
      <div class="content">
        <div class="right">
          <div @click="goToday" class="go-today">今天</div>
          <div class="rooms-info">
            <!-- 左边的房源列表 -->
            <div class="title">房间</div>

            <div
              id="rooms-list"
              class="rooms-list"
              ref="systemForm"
              @scroll="sysHandleScroll()"
              @mouseover="changeFlag(1)"
            >
              <div
                @click="housrInfo(item2)"
                v-for="(item2, i) in gridData"
                :key="'item2-' + i"
                class="room-item"
              >
                <img :src="item2.img" alt="" />
                <div class="room-item-text">
                  {{ item2.vHouseNickName || item2.name }}
                </div>
              </div>
            </div>
          </div>
          <!-- 上面的日期 -->
          <div id="room-status" class="room-status">
            <div
              :style="{
                width: daysDATA.totalDay * daysDATA.multiple * gridWidth + 'px'
              }"
              class="calendar"
            >
              <div
                :style="{ width: gridWidth + 'px' }"
                :data-item="'day-' + item.date"
                v-for="(item, index) in days"
                :key="index"
              >
                <div class="day">
                  <div v-if="item.isHolidays" class="isHolidays">
                    <img src="../../image/xiu.png" alt="" />
                  </div>
                  <div v-if="item.isWeekdays" class="isHolidays">
                    <img src="../../image/ban.png" alt="" />
                  </div>
                  {{ item.month }}-{{ item.day }}
                </div>

                <div
                  v-if="!item.isToday"
                  :class="{ weekend: item.isWeek }"
                  class="week"
                >
                  {{ item.weekStr }}
                </div>
                <div v-if="item.isToday" class="today">
                  今天
                </div>

                <div class="surplus">余{{item.houseNum||houseNum}}</div>
              </div>
            </div>
            <!-- 下面的list -->

            <div
              id="rooms"
              :style="{
                width: daysDATA.totalDay * daysDATA.multiple * gridWidth + 'px'
              }"
              class="rooms"
              ref="externalForm"
              @scroll="exterHandleScroll()"
              @mouseover="changeFlag(2)"
            >
              <div
                v-if="selectBoxShow"
                :style="{
                  left: selectBoxPosition.left + 'px',
                  top: selectBoxPosition.top + 'px',
                  width: selectBoxPosition.max - selectBoxPosition.min + 'px'
                }"
                class="select-box"
              ></div>
              <div
                class="rooms-line"
                v-for="(item, y) in gridData"
                :key="item.id"
              >
                <div v-for="(item2, x) in item.children" :key="x">
                  <div
                    id="rooms-line-box"
                    :class="{
                      'rooms-real': item2._isBuy,
                      'rooms-pitch': item2._isSelect
                    }"
                    class="rooms-item"
                    :style="{
                      width: gridWidth + 'px',
                      left: x * gridWidth + 'px'
                    }"
                    @mousemove="
                      roomMoveHandle($event, x, y, item2.date, item.id)
                    "
                    @mousedown="
                      roomDownHandle($event, x, y, item2.date, item.id)
                    "
                    @mouseup="roomUpHandle(item2)"
                  ></div>
                  <!-- iHouseStatus == 0 关房  iHouseStatus ==1 订房 -->
                  <div
                    class="check-in"
                    @click="checkInfo(item2)"
                    :style="{
                      width: gridWidth * item2._guestInfo.iStatusFlag + 'px',
                      left: x * gridWidth + 'px'
                    }"
                    v-if="
                      item2._isBuy &&
                        item2._guestInfo.iHouseStatus == 1 &&
                        item2.begin
                    "
                  >
                    <div
                      :class="[
                        'check-in_top',
                        item2._guestInfo.iHouseStatus == '1' ? 'yellow' : ''
                      ]"
                    >

                      <span v-if="item2._guestInfo.dataSources==1">微信小程序</span>
                      <span v-if="item2._guestInfo.dataSources==2">悠家</span>
                      <span v-if="item2._guestInfo.dataSources==3">美团</span>
                      <span v-if="item2._guestInfo.dataSources==4">途家</span>
                      <span v-if="item2._guestInfo.dataSources==5">小猪</span>
                      <span v-if="item2._guestInfo.dataSources==6">爱彼迎</span>

                    </div>
                    <div
                      :class="[
                        'check-in_bottom',
                        item2._guestInfo.iHouseStatus == '1' ? 'yellow' : ''
                      ]"
                    >
                      {{ item2._guestInfo.userName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="paging">
      <div class="block">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 15, 20]"
          :page-size="5"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 修改信息弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible_other"
      width="375px"
      :show-close="false"
    >
      <div class="userNickName">
        昵称：
        <div class="userNickName_input">
          <el-input
            v-model="houseIdNickName"
            placeholder="请输入内容"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_other = false" class="cancel"
          >取 消</el-button
        >
        <el-button type="primary" @click="save" class="add_new_btn"
          >保 存</el-button
        >
      </span>
    </el-dialog>
    <!-- 信息弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="346px"
      :before-close="handleClose"
    >
      <div class="info">
        <div class="info_top">
          <div class="top_left">
            <img :src="home_img" />
          </div>
          <div class="top_right">
            {{ home_title }}
          </div>
        </div>
        <div class="info_bottom" @click="chengename">
          <div class="bottom_left">昵称：{{ nickName|| home_title }}</div>
          <div class="bottom_right">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 左边弹出框 :wrapperClosable="false" -->
    <el-drawer
      :visible.sync="drawer"
      :direction="direction"
      :modal="false"
      width="360px"
      :show-close="false"
      :before-close="handleCloseLeft"
    >
      <el-tabs v-model="activeName" @tab-click="TabsClick" stretch>
        <el-tab-pane
          label="新建订单"
          name="first"
          v-if="this.OrdersOrHouse.id == undefined"
        >
          <div class="hoursInfo_box">
            <div class="hoursInfo_title">
              {{ OrdersOrHouse.vHousTitle }}
            </div>
            <div class="hoursInfo_message">
              整套出租丨{{ OrdersOrHouse.roomNumber }}室{{
                OrdersOrHouse.hallNumber
              }}厅丨{{ OrdersOrHouse.iBedNumber }}床丨可住{{
                OrdersOrHouse.iResidentNum
              }}人
            </div>
            <div class="hoursInfo_message">
              地址：{{ OrdersOrHouse.address }}
            </div>
            <div class="hoursInfo_date">
              {{ this.selectData[0] || this.noSlects[0] }}~{{
                this.selectData[this.selectData.length - 1] ||
                  this.noSlects[this.noSlects.length - 1]
              }}（共{{
                this.selectData.length == 0
                  ? this.noSlects.length
                  : this.selectData.length
              }}晚）
              <i class="el-input__icon iconfont iconriqixuanze"></i>
            </div>
            <div class="hoursInfo_title">
              基础信息
            </div>
            <!-- :rules="rules" -->
            <el-form
              :model="ruleForm"
              ref="ruleFormOne"
              label-width="70px"
              class="demo-ruleForm"
            >
              <el-form-item
                label="房客"
                prop="userName"
                :rules="[
                  { required: true, message: '请输入房客姓名', trigger: 'blur' }
                ]"
              >
                <el-input
                  v-model="ruleForm.userName"
                  placeholder="房客姓名"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="手机号"
                prop="phonenumber"
                :rules="[
                  {
                    required: true,
                    message: '请输入房客手机号码',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  v-model="ruleForm.phonenumber"
                  placeholder="房客手机号"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="来源"
                prop="dataSources"
                :rules="[
                  { required: true, message: '选择订单来源', trigger: 'change' }
                ]"
              >
                <el-select
                  v-model="ruleForm.dataSources"
                  placeholder="选择订单来源"
                >
                    <el-option
                        label="微信小程序"
                        value="1"
                        style="padding:0 10px"
                    ></el-option>
                  <el-option
                    label="悠家"
                    value="2"
                    style="padding:0 10px"
                  ></el-option>
                  <el-option
                    label="美团"
                    value="3"
                    style="padding:0 10px"
                  ></el-option>
                  <el-option
                    label="途家"
                    value="4"
                    style="padding:0 10px"
                  ></el-option>
                  <el-option
                    label="小猪"
                    value="5"
                    style="padding:0 10px"
                  ></el-option>
                  <el-option
                    label="爱彼迎"
                    value="6"
                    style="padding:0 10px"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="类型"
                prop="orderTypes"
                :rules="[
                  { required: true, message: '选择订单类型', trigger: 'change' }
                ]"
              >
                <el-select
                  v-model="ruleForm.orderTypes"
                  placeholder="选择订单类型"
                >
                  <el-option
                    label="线上订单"
                    value="1"
                    style="padding:0 10px"
                  ></el-option>
                  <el-option
                    label="优化单"
                    value="2"
                    style="padding:0 10px"
                  ></el-option>
                  <el-option
                    label="线下单"
                    value="3"
                    style="padding:0 10px"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div class="hoursInfo_title">
              收款
            </div>
            <el-form
              :model="ruleForm"
              ref="ruleForm"
              label-width="70px"
              class="demo-ruleForm"
            >
              <el-form-item label="已收房款">
                <el-input
                  v-model="ruleForm.payReceive"
                  placeholder="输入金额"
                ></el-input>
              </el-form-item>
              <el-form-item label="佣金">
                <el-input
                  v-model="ruleForm.commission"
                  placeholder="输入金额"
                ></el-input>
              </el-form-item>
              <el-form-item label="押金">
                <el-input
                  v-model="ruleForm.deposit"
                  placeholder="输入金额"
                ></el-input>
              </el-form-item>
              <el-form-item label="备注">
                <el-input
                  v-model="ruleForm.cMemo"
                  placeholder="填写备注"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="footer">
              <el-button class="cancel" @click="cancel('ruleFormOne')"
                >取 消</el-button
              >
              <el-button
                type="primary"
                class="add_new_btn"
                @click="addNewBtn('ruleFormOne')"
                >确 定</el-button
              >
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="订单详情" name="first" v-else>
          <div class="hoursInfo_box">
            <div class="hoursInfo_title">
              {{ OrdersOrHouse.vHousTitle }}
            </div>
            <div class="hoursInfo_message">
              整套出租丨{{ OrdersOrHouse.roomNumber }}室{{
                OrdersOrHouse.hallNumber
              }}厅丨{{ OrdersOrHouse.iBedNumber }}床丨可住{{
                OrdersOrHouse.iResidentNum
              }}人
            </div>
            <div class="hoursInfo_message">
              地址：{{ OrdersOrHouse.address }}
            </div>
            <div class="hoursInfo_date">
                {{ dateFormat('{y}-{m}-{d}',OrdersOrHouse.checkInTime) }}~
                {{dateFormat('{y}-{m}-{d}',OrdersOrHouse.leaveTime) }}（共{{ OrdersOrHouse.days }}晚）
              <i class="el-input__icon iconfont iconriqixuanze"></i>
            </div>
            <div class="hoursInfo_title">
              基础信息
            </div>
            <div class="message">
              <div class="message_title">状态：</div>
              <div class="message_info" v-if="OrdersOrHouse.type == 2">
                待确认
              </div>
              <div class="message_info" v-if="OrdersOrHouse.type == 3">
                待入住
              </div>
              <div class="message_info" v-if="OrdersOrHouse.type == 4">
                待完成
              </div>
              <div class="message_info" v-if="OrdersOrHouse.type == 5">
                已完成
              </div>
            </div>
            <div class="message">
              <div class="message_title">入离：</div>
              <div class="message_info">
                {{ dateFormat('{y}-{m}-{d}',OrdersOrHouse.checkInTime) }}~
                  {{dateFormat('{y}-{m}-{d}',OrdersOrHouse.leaveTime) }}
              </div>

              <span>（共{{ OrdersOrHouse.days }}晚）</span>
            </div>
            <div class="message">
              <div class="message_title">来源：</div>
<!--                 微信小程序 悠家 美团 途家 小猪 爱彼迎-->
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 1 &&
                    OrdersOrHouse.orderTypes == 1
                "
              >
                微信小程序+类型：线上订单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 2 &&
                    OrdersOrHouse.orderTypes == 1
                "
              >
                悠家+类型：线上订单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 3 &&
                    OrdersOrHouse.orderTypes == 1
                "
              >
                美团+类型：线上订单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 4 &&
                    OrdersOrHouse.orderTypes == 1
                "
              >
                途家+类型：线上订单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 5 &&
                    OrdersOrHouse.orderTypes == 1
                "
              >
                小猪+类型：线上订单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 6 &&
                    OrdersOrHouse.orderTypes == 1
                "
              >
                爱彼迎+类型：线上订单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 1 &&
                    OrdersOrHouse.orderTypes == 2
                "
              >
                微信小程序+类型：优化单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 2 &&
                    OrdersOrHouse.orderTypes == 2
                "
              >
                悠家+类型：优化单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 3 &&
                    OrdersOrHouse.orderTypes == 2
                "
              >
                美团+类型：优化单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 4 &&
                    OrdersOrHouse.orderTypes == 2
                "
              >
                途家+类型：优化单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources ==5 &&
                    OrdersOrHouse.orderTypes == 2
                "
              >
                小猪+类型：优化单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 6 &&
                    OrdersOrHouse.orderTypes == 2
                "
              >
                爱彼迎+类型：优化单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 1 &&
                    OrdersOrHouse.orderTypes == 3
                "
              >
                微信小程序+类型：线下单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 2 &&
                    OrdersOrHouse.orderTypes == 3
                "
              >
                悠家+类型：线下单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 3 &&
                    OrdersOrHouse.orderTypes == 3
                "
              >
                美团+类型：线下单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 4 &&
                    OrdersOrHouse.orderTypes == 3
                "
              >
                途家+类型：线下单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 5 &&
                    OrdersOrHouse.orderTypes == 3
                "
              >
                小猪+类型：线下单
              </div>
              <div
                class="message_info"
                v-if="
                  OrdersOrHouse.dataSources == 6 &&
                    OrdersOrHouse.orderTypes == 3
                "
              >
                爱彼迎+类型：线下单
              </div>
            </div>
            <div class="message">
              <div class="message_title">房客：</div>
              <div class="message_info">
                  {{OrdersOrHouse.numberOfPeople}} 人
<!--                {{ OrdersOrHouse.userName }}（{{ this.userData.length }}人）-->
              </div>
<!--              <div @click="userDataInfo" class="message_info_right">-->
<!--                详情-->
<!--              </div>-->
            </div>
            <div class="message">
              <div class="message_title">手机号：</div>
              <div class="message_info">{{ OrdersOrHouse.phone }}</div>
            </div>
            <!-- <div class="message">
              <div class="message_title">评价：</div>
              <div class="message_info">待入住</div>
            </div> -->

            <div class="hoursInfo_title">
              费用
            </div>
            <div class="message">
              <div class="message_title">房费：</div>
              <div class="message_info">￥{{ OrdersOrHouse.money }}</div>
              <div class="message_info_right" @click="messageDetail">明细</div>
            </div>
            <div class="message">
              <div class="message_title">押金：</div>
              <div class="message_info">￥{{ OrdersOrHouse.deposit }}</div>
            </div>
            <div class="message">
              <div class="message_title">佣金：</div>
              <div class="message_info">￥{{ OrdersOrHouse.commission }}</div>
            </div>
            <!-- <div class="hoursInfo_title">
              备注
            </div> -->

            <div class="hoursInfo_title">
              其他
            </div>
            <div class="message">
              <div class="message_title">订单号：</div>
              <div class="message_info">{{ OrdersOrHouse.id }}</div>
            </div>
            <div class="message">
              <div class="message_title">下单时间：</div>
              <div class="message_info">{{ OrdersOrHouse.creationTime }}</div>
            </div>
            <div class="message">
              <div class="message_title">渠道：</div>
<!--                微信小程序 悠家 美团 途家 小猪 爱彼迎-->
              <div class="message_info" v-if="OrdersOrHouse.dataSources == 1">
                微信小程序
              </div>
              <div class="message_info" v-if="OrdersOrHouse.dataSources == 2">
                悠家
              </div>
              <div class="message_info" v-if="OrdersOrHouse.dataSources == 3">
                美团
              </div>
              <div class="message_info" v-if="OrdersOrHouse.dataSources == 4">
                途家
              </div>
              <div class="message_info" v-if="OrdersOrHouse.dataSources == 5">
                小猪
              </div>
              <div class="message_info" v-if="OrdersOrHouse.dataSources == 6">
                爱彼迎
              </div>
            </div>
            <div class="footer">
              <el-button class="cancel" @click="handleCloseMessage"
                >取 消</el-button
              >
              <el-button
                type="primary"
                class="add_new_btn"
                @click="handleCloseMessage"
                >确 定</el-button
              >
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="房态" name="second">
          <div class="hoursInfo_box">
            <div class="hoursInfo_title">
              {{ OrdersOrHouse.vHousTitle }}
            </div>
            <div class="hoursInfo_message">
              整套出租丨{{ OrdersOrHouse.roomNumber }}室{{
                OrdersOrHouse.hallNumber
              }}厅丨{{ OrdersOrHouse.iBedNumber }}床丨可住{{
                OrdersOrHouse.iResidentNum
              }}人
            </div>
            <div class="hoursInfo_message">
              地址：{{ OrdersOrHouse.address }}
            </div>
            <div class="hoursInfo_date">
              {{ this.selectData[0] || this.noSlects[0] }}~{{
                this.selectData[this.selectData.length - 1] ||
                  this.noSlects[this.noSlects.length - 1]
              }}（共{{
                this.selectData.length == 0
                  ? this.noSlects.length
                  : this.selectData.length
              }}晚）
              <i class="el-input__icon iconfont iconriqixuanze"></i>
            </div>
            <div class="hoursInfo_title">
              房态
            </div>
            <!-- 修改房间状态 -->
            <div class="changeRoomStatus">
              <template>
                <el-radio v-model="RoomStatus.iHouseStatus" label="0"
                  >关房</el-radio
                >
                <el-radio v-model="RoomStatus.iHouseStatus" label="1"
                  >开房</el-radio
                >
              </template>
            </div>
            <div class="footer">
              <el-button class="cancel" @click="cancel">取 消</el-button>
              <el-button
                type="primary"
                class="add_new_btn"
                @click="RoomStatusPost"
                >确 定</el-button
              >
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="改价" name="third">
          <div class="hoursInfo_box">
            <div class="hoursInfo_title">
              {{ OrdersOrHouse.vHousTitle }}
            </div>
            <div class="hoursInfo_message">
              整套出租丨{{ OrdersOrHouse.roomNumber }}室{{
                OrdersOrHouse.hallNumber
              }}厅丨{{ OrdersOrHouse.iBedNumber }}床丨可住{{
                OrdersOrHouse.iResidentNum
              }}人
            </div>
            <div class="hoursInfo_message">
              地址：{{ OrdersOrHouse.address }}
            </div>
            <div class="hoursInfo_date">
              {{ this.selectData[0] || this.noSlects[0] }}~{{
                this.selectData[this.selectData.length - 1] ||
                  this.noSlects[this.noSlects.length - 1]
              }}（共{{
                this.selectData.length == 0
                  ? this.noSlects.length
                  : this.selectData.length
              }}晚）
              <i class="el-input__icon iconfont iconriqixuanze"></i>
            </div>
            <div class="hoursInfo_title">
              悠家房价
            </div>
            <!-- 一键改价 -->
            <el-form
              ref="changePrice"
              label-position="left"
              label-width="80px"
              :model="changePrice"
            >
              <el-form-item
                label="一键改价"
                prop="iPriceNumber"
                :rules="[
                  { required: true, message: '价格不能为空', trigger: 'blur' }
                ]"
              >
                <el-input v-model="changePrice.iPriceNumber"></el-input>
              </el-form-item>
            </el-form>
            <div class="footer">
              <el-button class="cancel" @click="cancel('changePrice')"
                >取 消</el-button
              >
              <el-button
                type="primary"
                class="add_new_btn"
                @click="changePricePost('changePrice')"
                >确 定</el-button
              >
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-drawer>
    <!-- 显示入住人数详情 -->
    <el-dialog
      :visible.sync="userDataVisible"
      width="375px"
      :before-close="userhandleClose"
    >
      <div class="VisibleBox">
        <div class="VisibleTitle">房客</div>
        <div class="userDataInfoList" v-for="item in userData" :key="item">
          {{ item }}
        </div>
      </div>
    </el-dialog>
    <!-- 显示入住账单详情 -->
    <el-dialog
      :visible.sync="billVisible"
      width="375px"
      :before-close="billhandleClose"
    >
      <div class="VisibleBox">
        <div class="VisibleTitle">付款明细</div>
        <div class="aggregate">
          <div class="aggregate_left">总计：</div>
          <div class="aggregate_right">￥{{ OrdersOrHouse.money }}</div>
        </div>
        <div class="detail">
          收费明细
        </div>
        <div class="aggregateList">
          <div class="aggregate_left">房费：</div>
          <div class="aggregate_right">￥{{ OrdersOrHouse.originalPrice }}</div>
        </div>
        <div class="aggregateList">
          <div class="aggregate_left">加客费：</div>
          <div class="aggregate_right">￥{{ OrdersOrHouse.addMoney }}</div>
        </div>
        <div class="aggregateList">
          <div class="aggregate_left">押金：</div>
          <div class="aggregate_right">￥{{ OrdersOrHouse.deposit }}</div>
        </div>
        <div class="aggregateList" v-if="OrdersOrHouse.discount !== 0">
          <div class="aggregate_left">房东优惠：</div>
          <div
            class="aggregate_right"
            v-if="OrdersOrHouse.discount == 'countLink'"
          >
            <span>连住优惠</span>-￥{{ OrdersOrHouse.discount }}
          </div>
          <div
            class="aggregate_right"
            v-if="OrdersOrHouse.discount == 'countNight'"
          >
            <span>今夜特价</span>-￥{{ OrdersOrHouse.discount }}
          </div>
          <div
            class="aggregate_right"
            v-if="OrdersOrHouse.discount == 'countNewHouse'"
          >
            <span>新房优惠</span>-￥{{ OrdersOrHouse.discount }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
let count = 0;
import {
    houseState,
    updateHouseNickName,
    RoomaddOrders,
    updateHouseStatus,
    fastUpdatePrice,
    getOrdersOrHouse,
    getTopicPC, mtOperateRs, updateSynStateStock, pigSyncPrice, selectExamine, getInventory, inventory
} from "../../api/index";
import { Debounce } from "../../utils/treating";
import mqtt from "mqtt";
import { MQTT_MQTTIP, MQTT_USERNAME, MQTT_PASSWORD } from "../../utils/MQtt";
import  {format} from  '@/utils/util'
function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(32).substring(1);
}
let MathRandom =
  S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
let MqttUserId = "clientid-" + MathRandom;
var client;
const options = {
  connectTimeout: 40000,
  clientId: MqttUserId,
  username: MQTT_USERNAME,
  password: MQTT_PASSWORD,
  clean: true,
  keepalive: 24000
};
client = mqtt.connect(MQTT_MQTTIP, options);
export default {
  data() {
    return {
      houseNum:0,
      formInline: {
        title: "",
        number: "",
        cStewardId:sessionStorage.getItem('userId')
      },
      billVisible: false,
      userDataVisible: false,
      userData: [],
      OrdersOrHouse: [],
      roomStatusLsft: "", //左右滚动
      noSlects: [], //已关闭房源
      // 一键改价
      changePrice: {
        houseId: "",
        iPriceNumber: "",
        dPriceStartTime: "",
        dPriceEndTime: "",
        iHouseStatus: "1"
      },
        tjUpdatePriceFrom:{
            "inventorys": [
                {
                    "begin_date": "2023-06-29",
                    "end_date": "2023-07-01",
                    "quantity": 1 //库存写死1
                }
            ],
            "prices": [
                {
                    "amount": 101, //价格
                    "begin_date": "2023-06-29",
                    "end_date": "2023-07-01"
                }
            ],
            "partner_pid": "YJH-0004413", //房间id
            "partner_uid": "YJH-0004413"
        },
      iPriceNumber: "", //房价
      flag: false,
      RoomStatus: {
        houseId: "",
        iHouseStatus: "1",
        checkInTime: "", //开始时间
        leaveTime: "" //离开时间
      },
      home_title: "",
      home_img: [],
      ruleForm: {
        userName: "", //用户姓名
        phonenumber: "", //客户手机号
        dataSources: "", //订单来源
        orderTypes: "1", //订单类型
        checkInTime: "", //开始时间
        leaveTime: "", //离开时间
        houseId: "", //房源编号
        payReceive: "", //已收房款
        commission: "", //佣金
        deposit: "", //押金
        cMemo: "", //备注
        days: "",
        type: 3,
        flag: 1
      },
      // tabs切换的值
      activeName: "first",
      // 左边弹出框
      drawer: false,
      direction: "rtl",
      houseId: "",
      nickName: "",
      houseIdNickName: "",
      scroll: "",
      ID: "",
      pageLoading: true, //加载时，数据刷新页面是否显示
      daysDATA: {},
      days: [], //？？？？
      oneGoToday: false,
      roomsListTop: 0,
      gridWidth: 50,
      gridData: [],
      infos: [], //订单状态
      // Closeroom:[],//关房状态
      singleList: [],

      gridShowSection: {
        min: 10,
        max: 20
      },
      total: 0,
      currentPage: 1,
      roomsId: null,
      isSelect: false,
      selectBoxShow: false,
      selectData: [],
      selectDataObj: [],
      selectBoxPosition: {
        left: 0,
        top: 0,
        x: 0,
        y: 0,
        min: 0,
        max: 0
      },
      // 是否显示
      dialogVisible: false,
      dialogVisible_other: false,
        pigRoomId:'',
      page: {
        year: "2021",
        month: "7",
        Num: "2",
        pageNum: 1,
        pageSize: 5
      },
      te: {
        year: "2021",
        month: "7",
        Num: "2",
        pageNum: 1,
        pageSize: 5
      },
      houseInfo: {
        houseId: "", //房源id
        ordersId: "" //订单id
      },
      mtopic: ""
    };
  },
  created() {
    // this.ID = "18727101380";
    // this.getTopicPCAjax();
    this.houseStateAjax();
  /*  this.$nextTick(() => {
      this.myMqtt();
    });*/
  },

  mounted() {
    // this.myMqtt();
    this.setDaysData();
    // window.addEventListener("scroll", this.scrollDs, true);
  },
  watch: {
    gridData() {
      this.$nextTick(() => {
        if (!this.oneGoToday) {
          this.oneGoToday = true;
          setTimeout(() => {
            // 去今天
            this.goToday();
            this.pageLoading = false; //页面刷新直接跳转到今天
            console.log(
              `全部dom渲染已完成,总耗时：${+new Date() -
                this.daysDATA.todayMs}ms`
            );
          }, 10);
        }
      });
    }
    // goBottom() {
    //   this.$nextTick(() => {
    //     var roomStatusLsft = document.getElementById("room-status");
    //     // console.log(roomStatusLsft);
    //   });
    // }
  },
  methods: {
    myMqtt() {
      // 连接mqtt
      client.on("connect", e => {
        console.log("连接成功", this.mtopic);
        client.subscribe(this.mtopic, err => {
          if (!err) {
            console.log("订阅成功:" + this.mtopic);
          }
        });
      });
      // 接收推送消息
      client.on("message", (topic, message) => {
        // this.msg = message.toString();
        console.log(topic);
        for (var i = 0; i < 1; i++) {
          console.log("接收推送信息：", message.toString(), "主题", topic); //````````````
          this.houseStateAjax();
          this.$notify.info({
            title: "消息",
            message: message.toString(),
            duration: 0
          });
        }
      });
      // 断开发起重连
      client.on("reconnect", error => {
        console.log("正在重连...", error);
      });
      // 链接异常处理
      client.on("error", error => {
        console.log("连接失败...", error);
      });
    },
    // 获取订阅主题
    async getTopicPCAjax() {
      const { data: res } = await getTopicPC();
      console.log(res.data.topic);
      this.mtopic = `msg/+/${res.data.topic}`;
    },
    messageDetail() {
      this.billVisible = true;
    },
    userDataInfo() {
      this.userDataVisible = true;
    },
      //日期格式化
      dateFormat(mart,str){
          console.log(mart,str)
          console.log(format(mart,new Date(str)))
         return format(mart,new Date(str))
      },
    checkInfo(e) {
        console.log(e)
      this.houseInfo.ordersId = e._guestInfo.id || "";
      this.houseInfo.houseId = e._guestInfo.houseId || "";
      this.getOrdersOrHouseGet();
      this.selectBoxShow = false;
      this.drawer = true;
    },
    // 查询房源信息
    async getOrdersOrHouseGet() {
      const { data: res } = await getOrdersOrHouse(this.houseInfo);

      this.OrdersOrHouse = res.data;
        console.log("OrdersOrHouse",this.OrdersOrHouse )
      if (res.data.userData)
        this.userData = res.data.userData.map(item => {
          return item.userName;
        });
    },
    // 滚动监听
    scrollDs() {
      this.roomStatusLeft = document.getElementById("room-status").scrollLeft;
      const toDay = new Date(); //34421
      if (18200 + 16500 <= this.roomStatusLeft) {
        const num = 11;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 15000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 16500
      ) {
        const num = 10;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 13500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 15000
      ) {
        const num = 9;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 12000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 13500
      ) {
        const num = 8;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 10500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 12000
      ) {
        const num = 7;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 9000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 10500
      ) {
        const num = 6;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 7500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 9000
      ) {
        const num = 5;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 6000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 7500
      ) {
        const num = 4;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 4500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 6000
      ) {
        const num = 3;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 3000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 4500
      ) {
        const num = 2;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 1500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 3000
      ) {
        const num = 1;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      // -------------大于今天的时候End---------------
      //-------------当前月份的时候Start-------------
      if (18200 - 1500 <= this.roomStatusLeft && this.roomStatusLeft < 18200) {
        const num = 0;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month + num == month) {
          this.te.year = year;
          this.te.month = month + num;
        }

        this.submit(this.te);
      }
      //-------------当前月份的时候End-------------
      if (
        18200 - 3000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 1500
      ) {
        const num = 1;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 4500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 3000
      ) {
        const num = 2;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 6000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 4500
      ) {
        const num = 3;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 7500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 6000
      ) {
        const num = 4;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }
        this.submit(this.te);
      }
      if (
        18200 - 9000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 7500
      ) {
        const num = 5;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 10500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 9000
      ) {
        const num = 6;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 12000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 10500
      ) {
        const num = 7;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 13500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 12000
      ) {
        const num = 8;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 15000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 13500
      ) {
        const num = 9;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 16500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 15000
      ) {
        const num = 10;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 18200 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 16500
      ) {
        const num = 11;
        const month = toDay.getMonth() + 1;
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
    },
    submit: Debounce(function(e) {
      console.log(e);
    }, 1000),
    // 修改价格
    changePricePost(formName) {
      this.changePrice.houseId = this.roomsId || "";
      this.changePrice.dPriceStartTime = this.selectData[0] || this.noSlects[0];
      this.changePrice.dPriceEndTime =
        this.selectData[this.selectData.length - 1] ||
        this.noSlects[this.noSlects.length - 1];
      //小猪改价参数
        let houseInfo = this.gridData.find(item=>{return item.id== this.houseInfo.houseId})
        let days = this.selectData.length>0?this.selectData:this.noSlects;
        console.log(houseInfo)
      let pigData={
          housingId:this.houseInfo.houseId.slice(0,this.houseInfo.houseId.lastIndexOf('-')),
          id:this.gridData.find(item=>{return item.id== this.houseInfo.houseId})?.pigUserId,
          priceArray:[]
      }
        this.selectData.forEach(item=>{
            let obj={}
            obj[item]=this.changePrice.iPriceNumber
            pigData.priceArray.push(obj)
            //pigData.priceArray[item.toString()]=this.changePrice.iPriceNumber
        })
       pigData.priceArray=JSON.stringify(pigData.priceArray)
        console.log(pigData)


      this.$refs[formName].validate(async valid => {
        if (valid) {
            const { data: re } = await pigSyncPrice(pigData);

                // 美团改价
            if(houseInfo?.productId){
                const { data: data1 } = await mtOperateRs({
                    dateList: days.map(item => format("{y}{m}{d}",item)),
                    price: this.changePrice.iPriceNumber || this.changePrice.iMeituanPrice,
                    productId: houseInfo?.productId
                });
            }


          const { data: res } = await fastUpdatePrice(this.changePrice);
          if (res.code !== 200)
            return this.$message({
              message: res.msg,
              type: "error"
            });
            if(houseInfo){

                this.updateTjInventory(days,houseInfo.id.slice(0,houseInfo.id.lastIndexOf('-')),this.changePrice.iPriceNumber).then(res=>{
                    if(res.data.code!=200){
                        this.$message({
                            message:'途家错误:'+ res.data.msg,
                            type: "error"
                        });
                    }
                })
            }
          this.changePrice = {
            houseId: "",
            iPriceNumber: "",
            dPriceStartTime: "",
            dPriceEndTime: "",
            iHouseStatus: "1"
          };
            this.$message.success('操作成功')
          this.houseStateAjax();
          this.drawer = false;
        } else {
          return false;
        }
      });
    },
    // 修改房源状态
    async RoomStatusPost() {
        //美团修改房源状态
        let dateList1=this.selectData.map(item=>{return item.replaceAll("-","")})
        let dateList2=this.noSlects.map(item=>{return item.replaceAll("-","")})

        console.log( dateList2)
        let houseInfo = this.gridData.find(item=>{return item.id==this.houseInfo.houseId});
        console.log(houseInfo)
        let days = this.selectData.length>0?this.selectData:this.noSlects;
        let mtData={
            dateList:dateList1.length>0?dateList1:dateList2,//最多30天
            openStatus:parseInt(this.RoomStatus.iHouseStatus),
            token:this.$store.state.MT_token,
            productId:this.gridData.find(item=>{return item.id==this.houseInfo.houseId})?.productId
        }
        console.log(mtData,this.gridData.find(item=>{return item.id==this.houseInfo.houseId}))
        if(mtData.productId){
            if(mtData.dateList.length>30){
                this.$message.warning('美团最多修改30天的房态');
                return ;
            }
            const { data: remt } = await mtOperateRs(mtData)
            if(remt.code!=200){
                  this.$message({
                    message:'美团错误:'+ remt.msg,
                    type: "error"
                });
            }
        }

        //修改小猪房态
        let pigData={
            statestock:{},
            id:this.gridData.find(item=>{return item.id==this.houseInfo.houseId})?.pigUserId
        }
        // let roomId=this.gridData.find(item=>{return item.id==this.houseInfo.houseId})?.roomId
        //不想写了懒一下
        let roomId=this.pigRoomId;
        pigData.statestock[roomId]={}

        console.log(roomId)
        if(this.selectData.length>0){
            this.selectData.forEach(item=>{
                pigData.statestock[roomId][item]={
                    stock:this.RoomStatus.iHouseStatus==1?1:0,//库存
                    state:parseInt(this.RoomStatus.iHouseStatus)//1可租0不可租
                }
            })
        }else {
            this.noSlects.forEach(item=>{
                pigData.statestock[roomId][item]={
                    stock:this.RoomStatus.iHouseStatus==1?1:0,
                    state:parseInt(this.RoomStatus.iHouseStatus)
                }
            })
        }

        console.log(pigData)
        pigData.statestock=JSON.stringify(pigData.statestock)
       if(pigData.id&&roomId){
           const { data: ree } = await updateSynStateStock(pigData)
           if(ree.code!=200){
                this.$message({
                   message:'小猪错误'+ ree.msg,
                   type: "error"
               });
           }
       }

        let tjUpdatePriceFrom = {
            "inventorys": [
                {
                    "begin_date":  days[0],
                    "end_date": days[days.length-1],
                    "quantity": this.RoomStatus.iHouseStatus==1?1:0,//库存
                }
            ],
            "partner_pid": houseInfo.id.slice(0,houseInfo.id.lastIndexOf('-')),
            "partner_uid": houseInfo.id.slice(0,houseInfo.id.lastIndexOf('-'))
        }

        //status 0修改房态 1修改房价
        console.log('途家入参===>',tjUpdatePriceFrom)
        inventory(tjUpdatePriceFrom).then(res=>{
            if(res.data.code!=200){
                this.$message({
                    message:'途家错误:'+ res.data.msg,
                    type: "error"
                });
            }
        })

      this.RoomStatus.houseId = this.roomsId || "";
      this.RoomStatus.checkInTime = this.selectData[0] || this.noSlects[0];
      this.RoomStatus.leaveTime =
        this.selectData[this.selectData.length - 1] ||
        this.noSlects[this.noSlects.length - 1];
      const { data: res } = await updateHouseStatus(this.RoomStatus);
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });


      this.RoomStatus = {
        houseId: "",
        iHouseStatus: "1",
        checkInTime: "", //开始时间
        leaveTime: "" //离开时间
      };
        this.$message.success('操作成功')
      this.houseStateAjax();
      this.drawer = false;
    },
    async updateTjPriceStaus(houseId,title){
        const data = await this.getInventory(houseId,title);
        this.updateTjInventory(data.data.data).then(res=>{
            if(res.data.code!=200){
                this.$message.error('途家错误:'+res.data.msg)
            }
        })
      },
      getInventory(houseId,title){
          return  getInventory({houseId,title});
      },
      updateTjInventory(dayList,houseId,price) {
          let startTime = dayList[0];
          let endTime = dayList[dayList.length-1]
          this.tjUpdatePriceFrom.inventorys[0].begin_date = startTime;
          this.tjUpdatePriceFrom.inventorys[0].end_date = endTime;
          this.tjUpdatePriceFrom.prices[0].begin_date = startTime;
          this.tjUpdatePriceFrom.prices[0].end_date = endTime;
          this.tjUpdatePriceFrom.prices[0].amount = price

          this.tjUpdatePriceFrom.partner_pid = houseId;
          this.tjUpdatePriceFrom.partner_uid = houseId
          //status 0修改房态 1修改房价
          console.log('途家入参===>', this.tjUpdatePriceFrom)
          return inventory(this.tjUpdatePriceFrom);
      },
    // 新建订单
   addNewBtn(formName) {
      this.ruleForm.checkInTime = this.selectData[0] || this.noSlects[0];
      this.ruleForm.leaveTime =
        this.selectData[this.selectData.length - 1] ||
        this.noSlects[this.noSlects.length - 1];
       this.ruleForm.checkInTime = format('{y}-{m}-{d} 14:00:00',new Date(this.ruleForm.checkInTime));
       this.ruleForm.leaveTime = format('{y}-{m}-{d} 12:00:00',new Date(this.ruleForm.leaveTime));

      this.ruleForm.houseId = this.roomsId || "";
      this.ruleForm.days = this.selectData.length;
       let houseInfo = this.gridData.find(item=>{return item.id==this.houseInfo.houseId});
       let days = this.selectData.length>0?this.selectData:this.noSlects;
      this.$refs[formName].validate(async valid => {
        if (valid) {
            //美团修改房源状态
            let dateList1=this.selectData.map(item=>{return item.replaceAll("-","")}).slice(0,29);
            let dateList2=this.noSlects.map(item=>{return item.replaceAll("-","")}).slice(0,29)
            console.log( dateList2)
            let mtData={
                dateList:dateList1.length>0?dateList1:dateList2,//最多30天
                openStatus:0,
                token:this.$store.state.MT_token,
                productId:this.gridData.find(item=>{return item.id==this.houseInfo.houseId})?.productId
            }
            console.log(mtData,this.gridData.find(item=>{return item.id==this.houseInfo.houseId}))
            if(mtData.productId){
                const { data: remt } = await mtOperateRs(mtData)
                if(remt.code!=200){
                    this.$message({
                        message:'美团错误:'+ remt.msg,
                        type: "error"
                    });
                }
            }

            //修改小猪房态
            let pigData={
                statestock:{},
                id:this.gridData.find(item=>{return item.id==this.houseInfo.houseId})?.pigUserId
            }
            let roomId=this.gridData.find(item=>{return item.id==this.houseInfo.houseId})?.roomId
            pigData.statestock[roomId]={}

            console.log(roomId)
            if(this.selectData.length>0){
                this.selectData.forEach(item=>{
                    pigData.statestock[roomId][item]={
                        stock:this.RoomStatus.iHouseStatus==0?1:0, //库存数量
                        state:parseInt(this.RoomStatus.iHouseStatus) //房间状态0不可租，1可租
                    }
                })
            }else {
                this.noSlects.forEach(item=>{
                    pigData.statestock[roomId][item]={
                        stock:1,
                        state:1
                    }
                })
            }

            console.log(pigData,pigData.statestock)
            pigData.statestock=JSON.stringify(pigData.statestock)
            if(pigData.id&&roomId){
                const { data: ree } = await updateSynStateStock(pigData)
                if(ree.code!=200){
                     this.$message({
                         message:'小猪错误:'+ ree.msg,
                        type: "error"
                    });
                }
            }
          //  修改途家房态
            let tjUpdatePriceFrom = {
                "inventorys": [
                    {
                        "begin_date":  days[0],
                        "end_date": days[days.length-1],
                        "quantity": this.RoomStatus.iHouseStatus==1?1:0,//库存
                    }
                ],
                "partner_pid": houseInfo.id.slice(0,houseInfo.id.lastIndexOf('-')),
                "partner_uid": houseInfo.id.slice(0,houseInfo.id.lastIndexOf('-'))
            }

            //status 0修改房态 1修改房价
            console.log('途家入参===>',tjUpdatePriceFrom)
            inventory(tjUpdatePriceFrom).then(res=>{
                if(res.data.code!=200){
                    this.$message({
                        message:'途家错误:'+ res.data.msg,
                        type: "error"
                    });
                }
            })
          const { data: res } = await RoomaddOrders(this.ruleForm);
          if (res.code !== 200)
            return this.$message({
              message: res.msg,
              type: "error"
            });

          this.ruleForm = {
            userName: "", //用户姓名
            phonenumber: "", //客户手机号
            dataSources: "", //订单来源
            orderTypes: "1", //订单类型
            checkInTime: "", //开始时间
            leaveTime: "", //离开时间
            houseId: "", //房源编号
            payReceive: "", //已收房款
            commission: "", //佣金
            deposit: "", //押金
            cMemo: "", //备注
            type: 5,
            flag: 1
          };
          this.$message.success('操作成功')
          this.$refs[formName].resetFields();
          this.houseStateAjax();
          this.drawer = false;
        } else {
          return false;
        }
      });
    },
    cancel(formName) {
      this.ruleForm = {
        userName: "", //用户姓名
        phonenumber: "", //客户手机号
        dataSources: "", //订单来源
        orderTypes: "1", //订单类型
        checkInTime: "", //开始时间
        leaveTime: "", //离开时间
        houseId: "", //房源编号
        payReceive: "", //已收房款
        commission: "", //佣金
        deposit: "", //押金
        cMemo: "", //备注
        type: 5,
        flag: 1
      };
      this.RoomStatus = {
        houseId: "",
        iHouseStatus: "1",
        checkInTime: "", //开始时间
        leaveTime: "" //离开时间
      };
      this.changePrice = {
        houseId: "",
        iPriceNumber: "",
        dPriceStartTime: "",
        dPriceEndTime: "",
        iHouseStatus: "1"
      };
      this.$refs[formName].resetFields();
      this.drawer = false;
    },
    // 修改昵称
    async save() {
      const { data: res } = await updateHouseNickName({
        houseId: this.houseId,
          vHouseNickName:this.houseIdNickName
        // vHouseNickName: this.houseIdNickName
      });
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.houseId = "";
      this.houseIdNickName = "";
      this.dialogVisible_other = false;
      this.dialogVisible = false;
      this.houseStateAjax();
      return this.$message({
        message: res.msg,
        type: "success"
      });
    },

    // 分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.houseStateAjax();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.houseStateAjax();
    },
    TabsClick(tab, event) {
      console.log(tab, event);
    },

    async houseStateAjax() {
      try {
          let formInline = {
              number: "",

          }
          if(sessionStorage.getItem('userId')!=1){
              formInline['cStewardId'] =sessionStorage.getItem('userId')

          }
          if(this.formInline.title.indexOf('YJH')!=-1){
              formInline['houseId'] = this.formInline.title
          }else {
              formInline['title'] = this.formInline.title
          }
        const { data: res } = await houseState(this.page, formInline);
        this.singleList = res.data.houseList;
       /* let num=0;
        let nowTime=format('{y}-{m}-{d}',new Date())
       res.data.testList.map(item=>{
        num+=  item.dateList.filter(ite=>ite==nowTime) .length;
       })*/
          this.days.forEach(item=>{
              let num=0;
              res.data.testList.map(it=>{
                  num+=  it.dateList.filter(ite=>ite==item.date).length;
              })
              item.houseNum=res.data.houseNum-num
          })
       //this.houseNum=res.data.houseNum-num
       // console.log(num,this.houseNum);
        // this.infos = res.data.statusList;
        this.infos = res.data.testList;
        this.total = res.data.total;
        this.setCustomer();
      } catch (error) {
        console.log(error);
      }
      // this.setCustomerList();
    },
    goToday() {
      setTimeout(() => {
        //点击前往今天
        document.getElementById("room-status").scrollLeft =
          (this.daysDATA.totalDay - 1) * this.gridWidth;
      }, 50);
    },
    changeFlag(flag) {
      this.flag = flag;
    },
    // 左右滚动条滚动同步
    sysHandleScroll() {
      if (this.flag == 1) {
        this.$refs.externalForm.scrollTop = this.$refs.systemForm.scrollTop;
      }
    },
    exterHandleScroll() {
      if (this.flag == 2) {
        this.$refs.systemForm.scrollTop = this.$refs.externalForm.scrollTop;
      }
    },

    // init() {
    //   // 绑定滑动事件
    //   const roomsListDom = document.getElementById("rooms-list"); //左边的房源列表
    //   const roomsDom = document.getElementById("rooms"); //list

    //   roomsDom.onscroll = e => {
    //     if (roomsListDom.scrollTop !== e.target.scrollTop)
    //       roomsListDom.scrollTop = e.target.scrollTop;
    //   };
    //   roomsListDom.onscroll = e => {
    //     if (roomsListDom.scrollTop !== e.target.scrollTop)
    //       roomsDom.scrollTop = e.target.scrollTop;

    //   };

    //   // 设置左边数据
    //   // this.setCustomer();
    // },
    roomDownHandle(e, x, y, date, roomsId) {
      //鼠标按下
      const target = e.target;
      // 清空之前的状态
      this.selectDataObj.forEach(v => {
        this.$set(v, "_isSelect", false);
      });
      this.selectDataObj = [];
      count = 0;
      this.selectBoxPosition.left = target.offsetLeft;
      this.selectBoxPosition.top = y * 50 + 96;
      this.selectBoxPosition.x = x;
      this.selectBoxPosition.y = y;
      this.selectBoxPosition.min = target.offsetLeft;
      this.selectBoxPosition.max = target.offsetLeft + this.gridWidth;
      this.isSelect = true;
      this.selectBoxShow = true;
      this.selectData = [];
      this.roomsId = roomsId;
      // console.dir(target)
    },

    roomUpHandle(e) {
      //鼠标抬起
      // const roomsListDom = document.getElementById("rooms-line-box");
      const section =
        (this.selectBoxPosition.max - this.selectBoxPosition.min) /
        this.gridWidth;
      const list = this.gridData[this.selectBoxPosition.y].children;
      this.noSlects = [];

      for (let i = 0; i < section; i++) {
        if (!list[this.selectBoxPosition.x + i]._isBuy) {
          this.$set(list[this.selectBoxPosition.x + i], "_isSelect", true);
          this.selectData.push(list[this.selectBoxPosition.x + i].date);
          this.selectDataObj.push(list[this.selectBoxPosition.x + i]);
        } else {
          this.noSlects.push(list[this.selectBoxPosition.x + i].date);
        }
      }
      this.isSelect = false;
      this.houseInfo.houseId = this.roomsId;
      this.selectExamine();
      this.getOrdersOrHouseGet();
      console.log(
        e,
        `当前选择结果为：${this.selectData}, 房间id为：${this.roomsId}, 未选中日期为：${this.noSlects}，原因：已售出`
      );
        console.log( this.houseInfo)
      // if (this.selectData.length < 2) return;

      this.drawer = true;
    },
    //  查询小猪回调
      selectExamine(){
          selectExamine({houseId:this.roomsId.slice(0,this.roomsId.lastIndexOf('-'))}).then(res=>{
              this.pigRoomId = res.data.data?.roomId
              console.log(res)
          })
      },
    roomMoveHandle(e, x, y, date) {
      count++;
      if (this.isSelect && count % 2 === 0) {
        if (e.target.offsetLeft > this.selectBoxPosition.min) {
          this.selectBoxPosition.max = e.target.offsetLeft + this.gridWidth;
        }
      }
    },

    // 单房源
    setCustomer() {
      this.gridData = this.singleList.map(v => {
        const children = [];
        this.days.forEach(v => {
          children.push({
            ...v
          });
        });
        return {
          id: v.houseId,
          name: v.vHousTitle,
          img: v.vCoverPic,
          nickName: v.vHouseNickName,
          productId:v.productId,
          pigUserId:v.pigUserId,
          roomId:v.roomId,
          vHouseNickName:v.vHouseNickName,
          children
        };
      });
      this.setCheckIn();
      console.log(
        `表格数据拼装完成,耗时：${+new Date() - this.daysDATA.todayMs}ms`
      );
    },
    setRooms(beginTime, endTime) {
      // 发请求 获取数据 改数据
    },
    // setCloseroom(infos = []){

    // },
    setCheckIn(infos = []) {
      // 客户订房信息
      // 根据接口请求
      const begin = +new Date();
      infos = this.infos;
      // infos = [
      //   {
      //     house_id: "YJH-00035-1", //id
      //     name: "王小二", //人名
      //     date: ["2021-5-20", "2021-5-21", "2021-5-22"], //订单日期
      //     from: "2", //来自那个平台,
      //     status: true, //房源状态,
      //     data: true
      //   },
      // ];
      this.gridData.forEach(grid => {
        infos.forEach(info => {
          if (info.houseId === grid.id) {
            grid.children.forEach(item => {
              if (info.dateList.indexOf(item.date) !== -1) {
                if (item._isBuy) {
                  this.$set(item, "_isBuy", true); //是否已定
                  this.$set(item, "_guestInfo", info);
                } else {
                  item._isBuy = true;
                  item._guestInfo = info;
                }
              }
              if (info.checkInTime.indexOf(item.date) !== -1) {
                if (item.begin) {
                  this.$set(item, "begin", true); //是否已定
                } else {
                  item.begin = true;
                }
              }
            });
          }
        });
      });
      console.log(`入住信息填充完成,耗时${+new Date() - begin}ms`);
    },
    setDaysData() {
      const oneDayMs = 86400000; //一天的时间
      const todayObj = new Date(); //今天的时间 Fri May 21 2021 14:10:26 GMT+0800 (中国标准时间)
      const todayMs = +new Date(); //当前的时间戳1621577377143
      const today = `${todayObj.getFullYear()}-${
        todayObj.getMonth() + 1 > 9
          ? todayObj.getMonth() + 1
          : "0" + (todayObj.getMonth() + 1)
      }-${
        todayObj.getDate() > 9 ? todayObj.getDate() : "0" + todayObj.getDate()
      }`; //年月日的格式2021-05-21
      const multiple = 2; //前后两年
      const totalDay = 365; //天数
      const totalDayMs = todayMs + totalDay * oneDayMs; //当前时间戳 + 365 * 每天的时间戳
      const days = [];
      // 节假日 后端获取
      const holidays = [
        "2021-01-01",
        "2021-01-02",
        "2021-01-03",
        "2021-02-11",
        "2021-02-12",
        "2021-02-13",
        "2021-02-14",
        "2021-02-15",
        "2021-02-16",
        "2021-02-17",
        "2021-04-03",
        "2021-04-04",
        "2021-04-05",
        "2021-05-01",
        "2021-05-02",
        "2021-05-03",
        "2021-05-04",
        "2021-05-05",
        "2021-05-12",
        "2021-05-13",
        "2021-05-14",
        "2021-09-19",
        "2021-09-20",
        "2021-09-21",
        "2021-10-01",
        "2021-10-02",
        "2021-10-03",
        "2021-10-04",
        "2021-10-05",
        "2021-10-06",
        "2021-10-07"
      ];
      // 工作日 后端获取
      const weekdays = [
        "2021-01-01",
        "2021-02-07",
        "2021-02-20",
        "2021-04-25",
        "2021-05-08",
        "2021-09-26",
        "2021-10-09"
      ];
      const weekMap = {
        0: "日",
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六"
      };
      // 节假日明细
      // const festivaldays = [];
      let daysDATA = {
        days,
        todayMs,
        today,
        totalDay,
        multiple
      };
      let count = 0;
      let begin = +new Date();
      for (let i = 0; i < totalDay * multiple; i++) {
        count++;
        const thatDay = new Date(totalDayMs - count * oneDayMs);
        const date = `${thatDay.getFullYear()}-${
          thatDay.getMonth() + 1 > 9
            ? thatDay.getMonth() + 1
            : "0" + (thatDay.getMonth() + 1)
        }-${
          thatDay.getDate() > 9 ? thatDay.getDate() : "0" + thatDay.getDate()
        }`; //当前单元格的年月日信息
        const obj = {
          date,
          dateSp: date.split("-"),
          dateNum: +`${thatDay.getFullYear()}${thatDay.getMonth() +
            1}${thatDay.getDate()}`,
          day: thatDay.getDate(),
          month: thatDay.getMonth() + 1,
          // day: thatDay.getDate(),
          week: thatDay.getDay() === 0 ? "7" : thatDay.getDay(),
          weekStr: weekMap[thatDay.getDay()], //一、二、三、四、五、六、日
          isToday: date === today, //是否是今天
          // isFestival: 1,
          isWeek: thatDay.getDay() === 0 || thatDay.getDay() === 6,
          isHolidays: holidays.indexOf(date) !== -1, //是否节假日
          isWeekdays: weekdays.indexOf(date) !== -1 //是否工作日
        };
        days.unshift(obj);
      }

      this.daysDATA = daysDATA;
      this.days = days;
        console.log(this.days)
      console.log(`生成日历数据已完成,耗时：${+new Date() - begin}ms`);
      return daysDATA;
    },
    housrInfo(e) {
      this.dialogVisible = true;
      // console.log(e);
      this.houseId = e.id;
      this.home_title = e.name;
      this.nickName = e.vHouseNickName;
      this.home_img=e.img;
    },
    handleClose(done) {
      done();
    },
    userhandleClose(done) {
      done();
    },
    billhandleClose(done) {
      done();
    },
    handleCloseMessage() {
      this.drawer = false;
      this.OrdersOrHouse = [];
      this.houseInfo = {
        houseId: "", //房源id
        ordersId: "" //订单id
      };
    },
    handleCloseLeft(done) {
      done();
      this.OrdersOrHouse = [];
      this.houseInfo = {
        houseId: "", //房源id
        ordersId: "" //订单id
      };
    },
    chengename() {
      this.dialogVisible_other = true;
    },
    reset() {
      this.formInline.title = "";
      this.formInline.number = "";
      this.houseStateAjax();
      this.page = {
        year: "2021",
        month: "7",
        Num: "2",
        pageNum: 1,
        pageSize: 5
      };
    },
    onSubmit() {
      (this.page = {
        year: "2021",
        month: "7",
        Num: "2",
        pageNum: 1,
        pageSize: 5
      }),
        this.houseStateAjax();
    }
  }
};
</script>

<style lang="less" scoped>
body,
html,
#app {
  width: 100%;
  height: 100%;
}
.RoomStatus {
  width: 100%;
  height: calc(100% - 50px);
}
.loading {
  display: flex;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: #fff;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  img {
    width: 600;
    height: 600px;
  }
}
.main {
  width: 100%;
  height: 92%;

  .content {
    display: flex;
    width: 100%;
    height: 100%;
    .left {
      width: 180px;
      height: 100%;
      flex: none;
      background: orange;
    }
    .right {
      flex: 1;
      position: relative;
      .go-today {
        position: absolute;
        z-index: 10;
        left: 55%;
        margin-left: -21px;
        bottom: 20px;
        width: 42px;
        height: 42px;
        font-size: 12px;
        color: #fff;
        font-weight: 400;
        border-radius: 50%;
        background-color: #2c80f0;
        text-align: center;
        line-height: 42px;
        cursor: pointer;
      }
      .rooms-info {
        border-top: 1px solid #e1e1e1;
        border-left: 1px solid #e1e1e1;
        border-bottom: 1px solid #e1e1e1;
        // padding-bottom: 50px;
        // height: 688px;
        height: 100%;
        width: 144px;
        overflow: hidden;
        position: absolute;
        // background: #f6f6f6;
        z-index: 1;
        .title {
          text-align: center;
          height: 96px;
          line-height: 96px;
          font-size: 24px;
          color: #000;
          font-weight: 400;
          border-bottom: 1px solid #b4cdff;
          border-right: 1px solid #b4cdff;
        }
        .rooms-list {
          // padding-bottom: 50px;
          height: calc(100% - 110px);
          overflow-y: auto;
          overflow-x: hidden;
          .room-item:hover {
            transform: translateZ(20px);
          }
          .room-item {
            position: relative;
            cursor: pointer;
            background-color: #fff;
            height: 50px;
            border-bottom: 1px solid #b1d2ff;
            border-right: 1px solid #b1d2ff;
            .room-item-text {
              position: absolute;
              left: 60px;
              top: 10px;
              width: 58px;
              height: 32px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
            img {
              margin: 12px 10px;
              margin-right: 0;
              vertical-align: middle;
              width: 40px;
              height: 27px;
            }
          }
        }

        .gridDataList {
          height: 36px;
          line-height: 36px;
          padding-left: 13px;
          font-size: 14px;
          color: #171a1e;
          background: rgba(64, 158, 255, 0.1);
          border-right: 1px solid #b1d2ff;
          border-bottom: 1px solid #b1d2ff;
        }
      }
      .room-status {
        // background-color: #f6f6f6;
        // padding-bottom: 50px;
        // overflow: hidden;
        width: 90%;
        height: 100%;
        overflow: auto;
        position: absolute;
        top: 0;
        right: 0;
        left: 144px;
        bottom: 0;
        border-right: 1px solid #b1d2ff;
        .calendar {
          height: 97px;
          display: flex;
          flex-wrap: nowrap;
          position: absolute;
          z-index: 13;
          background: #fff;
          left: 0;
          top: 0;
          border-top: 1px solid #b1d2ff;
          border-bottom: 1px solid #b1d2ff;

          div {
            flex: none;
            color: #a2a2a2;
            font-size: 12px;
            text-align: center;
            .day {
              position: relative;
              color: #666666;
              height: 30px;
              line-height: 30px;
              .isHolidays {
                position: absolute;
                // border-radius: 50%;
                // color: #fff;
                top: 0;
                right: 0;
                width: 24px;
                height: 24px;
                // text-align: center;
                // line-height: 14px;
                // font-size: 10px;
                // background: #eb5757;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
            .week {
              border-bottom: 1px solid #d9e6ff;
              padding-bottom: 5px;
              height: 30px;
              line-height: 30px;
              &.weekend {
                color: #ff5147;
              }
            }
            .today {
              border-bottom: 1px solid #d9e6ff;
              padding-bottom: 5px;
              height: 30px;
              line-height: 30px;
              color: #2f80ed;
            }
            .surplus {
              width: 51px;
              height: 36px;
              line-height: 36px;
              color: #111112;
              border-right: 1px solid #d9e6ff;
            }
          }
        }
        .rooms {
          border-left: 1px solid #b1d2ff;
          height: 100%;
          padding-top: 97px;
          position: relative;
          overflow-y: auto;
          overflow-x: hidden;
          color: #fff;
          .select-box {
            height: 50px;
            width: 50px;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 12;
            border: 2px solid #eb8327;
            border-radius: 3px;
            pointer-events: none;
          }
          .rooms-line {
            position: relative;
            height: 50px;
            border-bottom: 1px solid #b4cdff;
            display: flex;
            user-select: none;
            .rooms-item {
              // border-right: 1px solid #b1d2ff;
              // border-bottom: 1px solid #b1d2ff;
              height: 50px;
              position: absolute;
              z-index: 2;
              flex: none;
              background: #fff;
              background: url("../../image/shadow.png") 0 0 no-repeat;
              background-size: cover;
              &.rooms-real {
                border-right: 1px solid #b1d2ff;
                border-bottom: 1px solid #b1d2ff;
                background: url("../../image/off.png") 0 0 no-repeat;
              }
              &.rooms-pitch {
                border-right: 0;
                // border-bottom: 1px solid #b1d2ff;
              }
            }
            .check-in {
              z-index: 6;
              position: absolute;
              padding: 3px 0 0 3px;
              bottom: 0;
              height: 40px;
              line-height: 35px;
              text-align: center;
              border-radius: 3px;
              top:-3px;
              font-size: 12px;
              color: #fff;
              .check-in_top {
                border-radius: 5px 5px 0 0;
                line-height: 17px;
                font-size: 12px;
              }
              .check-in_bottom {
                border-radius: 0 0 5px 5px;
                line-height: 17px;
                font-size: 12px;
              }
            }
            .red {
              background-color: red;
            }
            .green {
              background-color: #219653;
            }
            .grey {
              background-color: #f6f6f6;
            }
            .yellow {
              background-color: #f6b439;
            }
          }
        }
      }
    }
  }
}
.dialog-footer {
  .add_new_btn {
    margin-left: 24px;
    width: 72px;
    height: 36px;
    background-color: #f6b439;
    border: 1px solid #f6b439;
    box-sizing: border-box;
    border-radius: 4px;
  }
  .cancel {
    width: 72px;
    height: 36px;
    background-color: #f2f2f2;
    border: 1px solid #e1e1e1;
    box-sizing: border-box;
    border-radius: 4px;
  }
}
/deep/.el-dialog__header {
  padding: 0px;
}
/deep/.el-dialog__headerbtn {
  right: 5px;
  top: 5px;
}
/deep/.el-dialog__body {
  padding: 15px;
  .info {
    height: 116px;
    .info_top {
      padding-bottom: 15px;
      height: 80px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      .top_left {
        float: left;
        height: 64px;
        width: 64px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .top_right {
        font-weight: bold;
        font-size: 16px;
        width: 250px;
        float: right;
        height: 44px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
    .info_bottom {
      padding-top: 15px;
      height: 37px;
      .bottom_left {
        font-size: 16px;
        width: 270px;
        float: left;
        overflow: hidden; //隐藏
        white-space: nowrap; //显示一行
        text-overflow: ellipsis; //。。。
      }
      .bottom_right {
        float: right;
      }
    }
  }
  .userNickName {
    line-height: 60px;
    padding: 0 15px;
    padding-top: 50px;
    height: 120px;
    .userNickName_input {
      float: right;
      width: 267px;
    }
  }
}
/deep/.el-dialog {
  border-radius: 12px;
}

/deep/.el-drawer__header {
  padding: 0;
  margin-bottom: 0;
}
/deep/.el-drawer__open .el-drawer.rtl {
  width: 400px !important;
  box-shadow: -4px 0px 4px rgba(0, 0, 0, 0.1);
}
/deep/.el-tabs__header {
  margin: 0;
}

/deep/.el-tabs__nav-wrap {
  padding-top: 14px;
  height: 54px;
}
/deep/.el-tabs__item.is-active {
  color: #f6b439;
}
/deep/.el-tabs__active-bar {
  background-color: #f6b439;
}
/deep/.el-tabs__item:hover {
  color: #f6b439;
}
.hoursInfo_box {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 20px 30px;
  .message {
    width: 100%;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    .message_title {
      float: left;
      text-align: right;
      color: #333333;
      width: 70px;
    }
    .message_info {
      float: left;
      span {
        color: #999999;
      }
    }
    .message_info_right {
      cursor: pointer;
      float: right;
      color: #2f80ed;
    }
  }
  .hoursInfo_title {
    width: 330px;
    height: 42px;
    font-size: 16px;
    line-height: 42px;
    font-weight: bold;
    color: #171a1e;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    // margin-bottom: 15px;
  }
  .hoursInfo_message {
    font-size: 14px;
    color: #333333;
    margin-bottom: 15px;
  }
  .hoursInfo_date {
    position: relative;
    width: 340px;
    height: 36px;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    margin-bottom: 20px;
    line-height: 34px;
    padding: 0 10px;
    i {
      font-size: 20px;
      position: absolute;
      right: 12px;
      bottom: 3px;
    }
  }
  /deep/.el-form-item {
    height: 36px;
    margin-bottom: 15px;
    color: #000000;
    .el-form-item__label {
      height: 36px;
    }
    .el-form-item__content {
      height: 36px;
      .el-input {
        height: 36px;
        .el-input__inner {
          height: 36px;
        }
      }
    }
    .el-select {
      width: 100%;
    }
    .el-input__icon {
      line-height: 36px;
    }
  }
  .footer {
    position: fixed;
    bottom: 30px;
    right: 30px;
    height: 36px;
  }
  .add_new_btn {
    height: 36px;
    width: 72px;
    margin-left: 24px;
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
  .cancel {
    height: 36px;
    width: 72px;
    background: #f2f2f2;
    border: 1px solid #e1e1e1;
  }
}
.paging {
  background-color: #fff;
  z-index: 1;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 9px;
}
.el-radio {
  margin-right: 30px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #f6b439;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #f6b439;
  background: #f6b439;
  width: 24px;
  height: 24px;
}
/deep/.el-radio__label {
  font-size: 16px;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #f6b439;
}
/deep/.el-radio__inner {
  width: 24px;
  height: 24px;
}
/deep/.el-radio__inner::after {
  width: 10px;
  height: 10px;
}
.VisibleBox {
  overflow: hidden;
  padding: 32px;
  .aggregate {
    height: 64px;
    line-height: 64px;
    font-size: 24px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    .aggregate_left {
      float: left;
    }
    .aggregate_right {
      float: right;
    }
  }
  .detail {
    height: 58px;
    line-height: 58px;
    font-size: 20px;
    color: #333333;
  }
  .aggregateList {
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    .aggregate_left {
      float: left;
    }
    .aggregate_right {
      float: right;
      span {
        color: #ea3a3c;
      }
    }
  }
  .aggregateList:nth-last-child(1) {
    border: none;
  }
}
.VisibleTitle {
  width: 100%;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  margin-top: -25px;
}
.userDataInfoList {
  text-align: center;
  line-height: 50px;
  font-size: 14px;
  float: left;
  width: 93px;
  height: 50px;
  padding: 25px;
}
/deep/.demo-form-inline {
  margin-bottom: 20px;
  .el-input__inner {
    width: 200px;
    height: 36px;
    font-size: 14px;
  }
  .left_margin {
    margin-left: 26px;
  }
  .inquire {
    width: 72px;
    height: 36px;
    margin-top: 2px;
    margin-left: -12px;
  }
  .el-button + .el-button {
    margin-left: 24px;
    width: 72px;
    height: 36px;
    background: #f6b439;
    border: 1px solid #f6b439;
  }
}
</style>
